import { HStack, Icon, Text, type SearchSelectProps } from '@talos/kyoko';
import { MonitoringIconLookup } from './constants';
import type { EntityName } from './types';

export const AutoCompleteDropdownGroupHeader = function AutoCompleteDropdownGroupHeader({ group }) {
  return (
    <HStack
      gap="spacing8"
      justifyContent="flex-start"
      alignItems="center"
      background="backgroundDropdownGroupHeader"
      py="spacing4"
      px="spacing12"
      fontSize="fontSizeSmall"
    >
      <Icon icon={MonitoringIconLookup[group.group as keyof typeof MonitoringIconLookup]} />
      <Text size="fontSizeSm" textTransform="uppercase" weight="fontWeightMedium">
        {group.group}
      </Text>
    </HStack>
  );
} satisfies NonNullable<SearchSelectProps<EntityName>['RenderGroupHeader']>;
